import {
    getUserSubscriptionType,
    getUserSubscriptionStatus,
    getUserSubscriptionDates,
    sha256,
    isUserLoggedIn,
    getPaywallType,
    getPaywallFreeVisitsLeft,
    getIssuePageNumber,
    ga4TrackingEcommerce,
    ga4TrackingSubscription,
    ga4TrackingPaywallBlocked,
    ga4TrackingPaywallNotBlocked
} from '../tools/utilities';

document.addEventListener('PelcroUserLoaded', (response, e) => {
    if (response?.detail?.data?.id) {
        let date = new Date();
        date.setTime(date.getTime() + 60 * 24 * 60 * 60 * 1000);
        document.cookie = `pelcro_user_id=${response?.detail?.data?.id}; path=/; expires=${date.toUTCString()}; Secure`;
    }
});

document.addEventListener('PelcroUserRegister', (response, e) => {
    if (response?.detail?.data?.id) {
        let date = new Date();
        date.setTime(date.getTime() + 60 * 24 * 60 * 60 * 1000);
        document.cookie = `pelcro_user_id=${response?.detail?.data?.id}; path=/; expires=${date.toUTCString()}; Secure`;
    }
});

document.addEventListener('PelcroUserLoggedIn', (response, e) => {
    if (response?.detail?.data?.id) {
        let date = new Date();
        date.setTime(date.getTime() + 60 * 24 * 60 * 60 * 1000);
        document.cookie = `pelcro_user_id=${response?.detail?.data?.id}; path=/; expires=${date.toUTCString()}; Secure`;
    }
});

document.addEventListener('PelcroUserLogout', () => {
    document.cookie = 'pelcro_user_id=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; Secure';
});

document.addEventListener('PelcroSubscriptionCreate', async (response, e) => {
    const subscriptionDates = getUserSubscriptionDates();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'Subscribed',
        loggedInStatus: 'true',
        loggedInUserID: `${response?.detail?.data?.id}`,
        subscribedStatus: getUserSubscriptionStatus(),
        subscriberType: getUserSubscriptionType(), // will be 'Digital', 'Bundle' or 'NoSub'
        subscription_start_date: subscriptionDates.subscription_start_date,
        subscription_renewal_date: subscriptionDates.subscription_renewal_date,
        cancellation_date: subscriptionDates.cancellation_date,
        user_data: {
            email: `${response?.detail?.data?.email}`,
            sha256_email_address: await sha256(`${response?.detail?.data?.email}`),
        },
    });

    window.__ciads = window.__ciads || { cmd: [] };
    window.__ciads.cmd.push(() => {
        window.__ciads.passSignalData('email', `${response?.detail?.data?.email}`);
        window.__ciads.setTargeting('subscribedStatus', getUserSubscriptionStatus());
        window.__ciads.setTargeting('loggedInStatus', 'true');
    });

    // Need to reload the page if paywall present as Pelcro doesn't remove the paywall after login
    const paywall = document.querySelector('#pelcro-paywall');
    const pelcroModal = document.querySelector('.pelcro-modal');
    if (paywall !== null && pelcroModal === null) {
        window.location.reload(false);
    }
});

document.addEventListener('PelcroElementsCartItemAdded', (response, e) => {
    if (response?.detail) {
        ga4TrackingEcommerce('add_to_cart', [response.detail]);

        const headerBasketButton = document.querySelector('[data-target="header-basket-button"]');
        if (headerBasketButton !== null) {
            setTimeout(() => {
                headerBasketButton.click();
            }, 500);
        }
    }
});

document.addEventListener('PelcroElementsCartOpened', (response, e) => {
    ga4TrackingEcommerce('view_cart', response.detail);
});

document.addEventListener('PelcroUserRegister', async (response, e) => {
    if (response?.detail?.data?.id) {
        const subscriptionDates = getUserSubscriptionDates();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'Registered',
            loggedInStatus: 'true',
            loggedInUserID: `${response?.detail?.data?.id}`,
            subscribedStatus: getUserSubscriptionStatus(),
            subscriberType: getUserSubscriptionType(), // will be 'Digital', 'Bundle' or 'NoSub'
            subscription_start_date: subscriptionDates.subscription_start_date,
            subscription_renewal_date: subscriptionDates.subscription_renewal_date,
            cancellation_date: subscriptionDates.cancellation_date,
            user_data: {
                email: `${response?.detail?.data?.email}`,
                sha256_email_address: await sha256(`${response?.detail?.data?.email}`),
            },
        });

        window.__ciads = window.__ciads || { cmd: [] };
        window.__ciads.cmd.push(() => {
            window.__ciads.passSignalData('email', `${response?.detail?.data?.email}`);
            window.__ciads.setTargeting('subscribedStatus', getUserSubscriptionStatus());
            window.__ciads.setTargeting('loggedInStatus', 'true');
        });
    }
});

document.addEventListener('PelcroUserLoggedIn', async (response, e) => {
    if (response?.detail?.data?.id) {
        const subscriptionDates = getUserSubscriptionDates();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'Logged in',
            loggedInStatus: 'true',
            loggedInUserID: `${response?.detail?.data?.id}`,
            subscribedStatus: getUserSubscriptionStatus(),
            subscriberType: getUserSubscriptionType(), // will be 'Digital', 'Bundle' or 'NoSub'
            subscription_start_date: subscriptionDates.subscription_start_date,
            subscription_renewal_date: subscriptionDates.subscription_renewal_date,
            cancellation_date: subscriptionDates.cancellation_date,
            user_data: {
                email: `${response?.detail?.data?.email}`,
                sha256_email_address: await sha256(`${response?.detail?.data?.email}`),
            },
        });

        window.__ciads = window.__ciads || { cmd: [] };
        window.__ciads.cmd.push(() => {
            window.__ciads.passSignalData('email', `${response?.detail?.data?.email}`);
            window.__ciads.setTargeting('subscribedStatus', getUserSubscriptionStatus());
            window.__ciads.setTargeting('loggedInStatus', 'true');
        });

        // Need to reload the page if paywall present as Pelcro doesn't remove the paywall after login
        const paywall = document.querySelector('#pelcro-paywall');
        const pelcroModal = document.querySelector('.pelcro-modal');
        if (paywall !== null && pelcroModal === null) {
            window.location.reload(false);
        }
    }
});

document.addEventListener('PelcroUserLogout', () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'Logged out',
        loggedInStatus: 'false',
        loggedInUserID: '',
        subscribedStatus: 'false',
        subscriberType: 'NoSub',
        subscription_start_date: 'NA',
        subscription_renewal_date: 'NA',
        cancellation_date: 'NA',
        user_data: {
            email: '',
            sha256_email_address: '',
        },
    });
});

document.addEventListener('PelcroUserLoaded', async (response, e) => {
    if (response?.detail?.data?.id) {
        const subscriptionDates = getUserSubscriptionDates();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'user_info_added',
            loggedInStatus: 'true',
            loggedInUserID: `${response?.detail?.data?.id}`,
            subscribedStatus: getUserSubscriptionStatus(),
            subscriberType: getUserSubscriptionType(),
            subscription_start_date: subscriptionDates.subscription_start_date,
            subscription_renewal_date: subscriptionDates.subscription_renewal_date,
            cancellation_date: subscriptionDates.cancellation_date,
            user_data: {
                email: `${response?.detail?.data?.email}`,
                sha256_email_address: await sha256(`${response?.detail?.data?.email}`),
            },
        });

        window.__ciads = window.__ciads || { cmd: [] };
        window.__ciads.cmd.push(() => {
            window.__ciads.passSignalData('email', `${response?.detail?.data?.email}`);
            window.__ciads.setTargeting('subscribedStatus', getUserSubscriptionStatus());
            window.__ciads.setTargeting('loggedInStatus', 'true');
        });
    }
});

if (!isUserLoggedIn()) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'user_info_added',
        loggedInStatus: 'false',
        loggedInUserID: '',
        subscribedStatus: 'false',
        subscriberType: 'NoSub',
        subscription_start_date: 'NA',
        subscription_renewal_date: 'NA',
        cancellation_date: 'NA',
        user_data: {
            email: '',
            sha256_email_address: '',
        },
    });

    document.addEventListener('DOMContentLoaded', event => {
        window.__ciads = window.__ciads || { cmd: [] };

        let attempts = 0;
        let intervalID = setInterval(function() {
            // Check for CMD before pushing
            if (window.__ciads.cmd) {
                window.__ciads.cmd.push(() => {
                    window.__ciads.setTargeting('subscribedStatus', getUserSubscriptionStatus());
                    window.__ciads.setTargeting('loggedInStatus', 'false');
                });
                window.clearInterval(intervalID);
            }

            if (++attempts === 5) {
                window.clearInterval(intervalID);
            }
        }, 1000);
    });
}

document.addEventListener('PelcroPaywallDisplayed', () => {
    ga4TrackingPaywallBlocked();
}, { once: true });

document.addEventListener('PelcroPaywallNotDisplayed', () => {
    ga4TrackingPaywallNotBlocked();
}, { once: true });
